import hrms18eLabels from 'assets/labels/hrms18e'
import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms18eLabels
    }
  },
  index (searchParams) {
    let codcalens = [ '0001', '0002', '0003', '0004' ]
    let codshift = [ 'D1', 'D2', 'D3', 'D4' ]
    let typwork = [ 'H', 'W', 'S', 'T', 'L' ]
    let descCodcalens = [ 'desc_codcalen_0001', 'desc_codcalen_0002', 'desc_codcalen_0003', 'desc_codcalen_0004' ]
    const mockParentTotal = codcalens.length
    let mockParentRows = []
    let dayInMonth = moment(moment().format(searchParams.year + '-' + _.padStart(searchParams.month, 2, '0') + '-01')).daysInMonth()
    let mockChildTotal = 0
    let mockChildRows = []
    for (var parentRow = 1; parentRow <= mockParentTotal; parentRow++) {
      let mockParentRow = {
        codcomp: searchParams.codcomp,
        codcalen: codcalens[parentRow - 1],
        desc_codcalen: descCodcalens[parentRow - 1],
        month: _.padStart(searchParams.month, 2, '0'),
        year: searchParams.year
      }
      for (let day = 1; day <= dayInMonth; day++) {
        let rand = Math.floor(Math.random() * 100)
        let randTypwork = 2
        if (rand >= 0 && rand < 66) {
          randTypwork = 1 // 'W'
        } else if (rand >= 66 && rand < 96) {
          randTypwork = 0 // 'H'
        } else if (rand >= 96 && rand < 99) {
          randTypwork = 3 // 'T'
        }
        mockParentRow['codshift' + _.padStart(day, 2, '0')] = codshift[Math.floor(Math.random() * (codshift.length * 1) - 0.01)]
        mockParentRow['typwork' + _.padStart(day, 2, '0')] = typwork[randTypwork]
      }
      mockParentRows.push(mockParentRow)

      const mockChildTotalInGroup = 10
      mockChildTotal += mockChildTotalInGroup
      for (var childRow = 1; childRow <= mockChildTotalInGroup; childRow++) {
        let mockChildRow = {
          codempid: faker.lorem.word(),
          desc_codempid: faker.name.findName(),
          month: _.padStart(searchParams.month, 2, '0'),
          year: searchParams.year
        }
        for (let day = 1; day <= dayInMonth; day++) {
          mockChildRow['codcalen' + _.padStart(day, 2, '0')] = mockParentRow['codcalen']
          mockChildRow['codshift' + _.padStart(day, 2, '0')] = mockParentRow['codshift' + _.padStart(day, 2, '0')]
          mockChildRow['typwork' + _.padStart(day, 2, '0')] = (Math.floor(Math.random() * 100) > 1) ? mockParentRow['typwork' + _.padStart(day, 2, '0')] : 'L'
        }
        mockChildRows.push(mockChildRow)
      }
    }

    return {
      table1: {
        total: mockParentTotal,
        rows: mockParentRows
      },
      table2: {
        total: mockChildTotal,
        rows: mockChildRows
      }
    }
  },
  saveIndex () {
    return labels.mockPostMessage
  },
  traditionalAndShutdownDays (year) {
    let traditionalDays = [
      {
        year: '2017',
        month: '12',
        day: '01',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '02',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '03',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '04',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '05',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '06',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '07',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '08',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '09',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '10',
        codcalen: ['0001', '0002', '0003']
      }
    ]
    let shutdownDays = [
      {
        year: '2017',
        month: '12',
        day: '11',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '12',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '13',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '14',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '15',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '16',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '17',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '18',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '19',
        codcalen: ['0001', '0002', '0003']
      }, {
        year: '2017',
        month: '12',
        day: '20',
        codcalen: ['0001', '0002', '0003']
      }
    ]
    return {
      traditional: {
        total: traditionalDays.length,
        rows: traditionalDays
      },
      shutdown: {
        total: shutdownDays.length,
        rows: shutdownDays
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms18e/mocker.js